import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-configuration-steps-bar',
  templateUrl: './configuration-steps-bar.component.html',
  styleUrls: ['./configuration-steps-bar.component.scss'],
  standalone: false,
})
export class ConfigurationStepsBarComponent {
  @Input() currentStep: number = 0;
  @Input() steps: Array<{key: number, value: string}> = [];
  @Output() selectStep: EventEmitter<number> = new EventEmitter<number>();
}
